import { render, staticRenderFns } from "./c_tur_rezervasyon_form.vue?vue&type=template&id=36b02e14"
import script from "./c_tur_rezervasyon_form.vue?vue&type=script&lang=js"
export * from "./c_tur_rezervasyon_form.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./c_tur_rezervasyon_form.vue?vue&type=style&index=1&id=36b02e14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports